export default "__VITE_ASSET__BuFjiqlv__"